/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import PerfectScrollbar from 'react-perfect-scrollbar';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';
// import Paper from '@mui/material/Paper';
import UndoIcon from '@mui/icons-material/Undo';
// import { styled } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
// import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
// import { Input } from 'antd';
import Snackbar from '@mui/material/Snackbar';
import InputAdornment from '@mui/material/InputAdornment';
import { CSVLink } from 'react-csv';
import {
  // Avatar,
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Typography,
  Button,
  TableContainer,
  TableFooter,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Alert
} from '@material-ui/core';
// import getInitials from 'src/utils/getInitials';
import Grid from '@mui/material/Grid';
import Loader from 'react-loader-spinner';
import { makeStyles } from '@mui/styles';
import { URL } from '../../utils/factory';

// const Item = styled(Paper)(({ theme }) => ({
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary
// }));
const axios = require('axios');

const moment = require('moment');

const useStyles = makeStyles({
  root: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '10px',
    border: 'none',
    borderRadius: '5px',
    textTransform: 'uppercase',
    fontWeight: 'bold'
  }
});
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

const styletable = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1350,
  bgcolor: 'white',
  border: '2px solid #fff',
  boxShadow: 24,
  p: 4
};

const stylefooter = {
  size: 18
};
const istyle = {
  color: 'red'
};

const csvbutton = {
  color: '#ffffff',
  display: 'block',
  width: '131px',
  height: '37px',
  textAlign: 'center',
  paddingTop: '6px',
  borderRadiusr: '4px',
  position: 'relative',
  backgroundColor: '#000000',
  boxShadow: '0 0 1px 0 rgb(0 0 0 / 31%), 0 2px 2px -2px rgb(0 0 0 / 25%)',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  fontWeight: '500',
  fontSize: '0.875rem',
  lineHeight: '1.75',
  letterSpacing: '0.02857em',
  textTransform: 'uppercase'
};
const CustomerListResults = ({
  customers,
  // getchilddata,
  flagstatus,
  fromdate,
  todate,
  datesearch,
  bookedfilter,
  loaderflag,
  exportlist,
  handleExportGrid,
  exportflag,
  handleExportGridTwo,
  exportlisttwo,
  exportflagver,
  exportflagverCSV,
  handelCsvButon,
  invoicelistexportcsv,
  ...rest
}) => {
  const [invoicelist, setInvoicelList] = useState([]);
  const [invoiceviewlist, setInvoiceViewlList] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaderstate, setLoaderstate] = useState(false);

  const [openview, setOpenView] = useState(false);

  const [invoiceid, setInvoiceId] = useState('');
  const [invremarks, setInvRemarks] = useState('');
  const [errormsg, setErrorMsg] = useState(false);
  const [totalcbm, setTotalCbm] = useState(0);
  const [totalbox, setTotalBox] = useState(0);
  const [totalqty, setTotalQty] = useState(0);

  const [saleReturn, setSaleReturn] = useState(0);
  const [standard, setStandard] = useState(0);
  const hide = false;
  // const [exportbtnflag, setExportBtnFlag] = useState(false);

  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [previnvoicelist, setPrevInvoiceList] = useState([]);
  const [singleselectinv, setSingleSelectInv] = useState('0');
  const [openunchecked, setOpenUnchecked] = useState(false);
  const [invreason, setInvreason] = useState('');
  const [updatemsg, setUpdateMsg] = useState(false);
  const [totalinvoice, setTotalInvoice] = useState('0');
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [openEdit, setOpenEdit] = useState(false);
  const [editInvoiceData, setEditInvoiceData] = useState('');
  const [editInvoiceDate, setChangeDripdownValue] = useState('');
  const [insertPrice, setInsertPrice] = useState('');
  const [deliveryEditData, setDeliveryEditData] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState('');
  const [invoiceAmount, setInvoiceAmount] = useState('');
  const [dropDownData, setDropDownData] = useState(null);
  const [sneakBarMessage, setSneakBarMessage] = useState('');
  const [sneakOpen, setSneakOpen] = useState(false);

  console.log(
    'standard::::::::::saleReturn::::::::::'
  );

  console.log(
    '@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
    sneakBarMessage
  );

  const classes = useStyles();
  // const [open2, setOpen2] = useState(false);

  // const readData = async () => {
  //   const clientid = localStorage.getItem('tranuserid');
  //   try {
  //     axios
  //       .post(`${URL}trans_loaditems`, {
  //         userid: clientid,
  //         qtype: '1',
  //         searchtext: '',
  //         fdate: '',
  //         tdate: '',
  //         headers: {
  //           'Access-Control-Allow-Origin': '*',
  //           'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
  //         }
  //       })
  //       .then((response) => {
  //         if (response.data.d.length > 0) {
  //           // eslint-disable-next-line no-eval
  //           const userdata = eval(response.data.d);
  //           setInvoicelList(userdata);
  //           // getchilddata(userdata);
  //           setPrevInvoiceList(userdata);
  //         } else setInvoicelList([]);
  //       })
  //       .catch((error) => {
  //         console.log('API error', error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleChangeselect = (event) => {
    const data = event.target.value;
    setChangeDripdownValue(event.target.value);
    if (data === 0) {
      setDropDownData('Cancellation');
    }
    if (data === 1) {
      setDropDownData('Labour Hire');
    }
    if (data === 2) {
      setDropDownData('Assembly');
    }
    if (data === 3) {
      setDropDownData('Rubbish Removal');
    }
  };
  const handleInsertPrice = (event) => {
    const regularExpression = /^[0-9\b]+$/;

    if (
      // eslint-disable-next-line operator-linebreak
      event.target.value === '' ||
      regularExpression.test(event.target.value)
    ) {
      setInsertPrice(event.target.value);
    }
  };

  const readViewData = async (id) => {
    setInvoiceId(id);
    setTotalCbm(0);
    setTotalBox(0);
    setTotalQty(0);
    const clientid = localStorage.getItem('tranuserid');
    try {
      axios
        .post(`${URL}trans_loaditems`, {
          userid: clientid,
          qtype: '2',
          searchtext: id,
          fdate: '',
          tdate: '',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoiceViewlList(userdata);
            let totcbm = 0;
            let totqty = 0;
            let totbox = 0;
            let totstdbox = 0;
            let totrtnbox = 0;

            for (let i = 0; i < userdata.length; i++) {
              totcbm = parseFloat(
                parseFloat(totcbm) + parseFloat(userdata[i].TotalCBM)
              );
              totqty = parseFloat(
                parseFloat(totqty) + parseFloat(userdata[i].Itd_qty)
              );

              totbox = parseFloat(
                parseFloat(totbox) + parseFloat(userdata[i].TotalBoxes)
              );

              // console.log('Total::::::::::::::', totcbm);
              // console.log(
              //   'TotalCBM::::::::::::::',
              //   userdata[i].TotalCBM
              // );
              if (userdata[i].DeliveryType === 'Standard') {
                totstdbox = parseFloat(
                  parseFloat(totstdbox) + parseFloat(userdata[i].TotalBoxes)
                );
              }

              if (userdata[i].DeliveryType === 'Sales Return') {
                totrtnbox = parseFloat(
                  parseFloat(totrtnbox) + parseFloat(userdata[i].TotalBoxes)
                );
              }
            }
            // const totalsale = userdata.filter(
            //   (a) => a.DeliveryType === 'Sales Return'
            // );

            // const totalStandard = userdata.filter(
            //   (a) => a.DeliveryType === 'Standard'
            // );
            setSaleReturn(totrtnbox);
            setStandard(totstdbox);
            setTotalCbm(totcbm.toFixed(2));
            setTotalBox(totbox.toFixed(2));
            setTotalQty(totqty.toFixed(2));
          } else setInvoiceViewlList([]);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpen = (event, id, remarks, type) => {
    setErrorMsg(false);
    setInvoiceId(id);
    setInvRemarks(remarks);
    if (type === 'remarks') setOpen(true);
    else {
      setInvoiceViewlList([]);
      readViewData(id);
      setOpenView(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setOpenView(false);
    setOpenEdit(false);
    setSneakBarMessage('');

    setInvoiceAmount('');
    setInvoiceDate('');
    setEditInvoiceData('');

    setDeliveryEditData([]);
  };

  const handleCloseSneakBar = () => {
    setSneakOpen(false);
  };

  const handleConfirmEditExcel = () => {
    try {
      axios
        .post(`${URL}sTrnasinvoivemain`, {
          invoiceno: editInvoiceData && editInvoiceData,
          fdate: invoiceDate && invoiceDate,
          qtype: '2',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          setOpenEdit(false);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (errorMessage) {
      console.log('Error inside handle save invoice', errorMessage);
    }
  };

  const handleRemarksChange = (event) => {
    setInvRemarks(event.target.value);
  };

  useEffect(() => {
    if (flagstatus) {
      setPrevInvoiceList(customers);
      setInvoicelList(customers);
      setTotalInvoice(customers.length);
      setRowsPerPage(20);
      setPage(0);
    } else {
      //  readData();
    }
  }, [customers, flagstatus]);

  useEffect(() => {
    setLoaderstate(loaderflag);
  }, [loaderflag]);
  // const handleSelectDispatch = (event, id) => {
  //   const clientid = localStorage.getItem('tranuserid');
  //   try {
  //     axios
  //       .post(`${URL}trans_updateitems`, {
  //         userid: clientid,
  //         qtype: '2',
  //         invoiceId: id,
  //         remarks: '',
  //         bookstatus: '0',
  //         disstatus: '1',
  //         headers: {
  //           'Access-Control-Allow-Origin': '*',
  //           'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
  //         }
  //       })
  //       .then((response) => {
  //         // eslint-disable-next-line no-eval
  //         // setInvoicelList(userdata);
  //         console.log(response);
  //         readData();
  //       })
  //       .catch((error) => {
  //         console.log('API error', error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleRemarks = () => {
    const clientid = localStorage.getItem('tranuserid');
    setErrorMsg(false);
    try {
      if (invremarks === '') {
        setErrorMsg(true);
      } else {
        setOpen(false);
        axios
          .post(`${URL}trans_updateitems`, {
            userid: clientid,
            qtype: '3',
            invoiceId: invoiceid,
            remarks: invremarks,
            bookstatus: '1',
            disstatus: '0',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
            }
          })
          .then(() => {
            // eslint-disable-next-line no-eval
            // const userdata = eval(response.data.d);
            // setInvoicelList(userdata);
            // console.log(response.data.d);
            datesearch(fromdate, todate);
          })
          .catch((error) => {
            console.log('API error', error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;
    // console.log('Prev Invoice:::::::::::', invoicelist);
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);
      setSelectedCustomerIds(newSelectedCustomerIds);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (invoicelist[z].inv_id === newSelectedCustomerIds[i]) {
            invoicelist[z].Itd_IsTransBooked = 'Booked';
            invoicelist[z].chkTransBooked = 'Yes';
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      console.log('invoicelist Invoice:::::::::::', previnvoicelist);
      setSelectedCustomerIds(newSelectedCustomerIds);
      // console.log('in uss:::::::::', customers);

      // console.log('Prev Invoice:::::::::::', previnvoicelist);
      // console.log('Prev Invoice:::::::::::', invoicelist);

      for (let z = 0; z < invoicelist.length; z++) {
        invoicelist[z].Itd_IsTransBooked = invoicelist[z].Itd_IsTransBookedold;
        invoicelist[z].chkTransBooked = invoicelist[z].chkTransBookedold;
      }

      // setInvoicelList(previnvoicelist);
    }
  };
  const handleSelectSingle = (event, invoiceidsingle) => {
    let newSelectedCustomerIds;
    console.log('Prev Invoice:::::::::::', invoiceidsingle);
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);
      setSelectedCustomerIds(newSelectedCustomerIds);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (
            // eslint-disable-next-line operator-linebreak
            invoicelist[z].inv_id === newSelectedCustomerIds[i] &&
            invoicelist[z].inv_id === invoiceidsingle
          ) {
            invoicelist[z].chkTransBooked = 'Yes';
            invoicelist[z].Itd_IsTransBooked = 'Booked';
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      // console.log('invoicelist Invoice:::::::::::', previnvoicelist);
      setSelectedCustomerIds(newSelectedCustomerIds);
      // console.log('in uss:::::::::', customers);

      // console.log('Prev Invoice:::::::::::', previnvoicelist);
      // console.log('Prev Invoice:::::::::::', invoicelist);

      for (let z = 0; z < invoicelist.length; z++) {
        if (invoicelist[z].inv_id === invoiceidsingle) {
          // eslint-disable-next-line operator-linebreak
          invoicelist[z].Itd_IsTransBooked =
            invoicelist[z].Itd_IsTransBookedold;
          invoicelist[z].chkTransBooked = invoicelist[z].chkTransBookedold;
        }
      }

      // setInvoicelList(previnvoicelist);
    }
  };
  const handleUpdateSelected = () => {
    setLoaderstate(true);
    setUpdateMsg(false);
    let selectedinv = '';
    for (let z = 0; z < invoicelist.length; z++) {
      if (invoicelist[z].chkTransBooked === 'Yes') {
        // eslint-disable-next-line prefer-template
        selectedinv += ',' + invoicelist[z].inv_id;
      }
    }
    // console.log(selectedinv);
    const clientid = localStorage.getItem('tranuserid');
    setErrorMsg(false);
    try {
      setOpen(false);
      axios
        .post(`${URL}trans_updateitems`, {
          userid: clientid,
          qtype: '1',
          invoiceId: selectedinv,
          remarks: '',
          bookstatus: '1',
          disstatus: '0',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          // eslint-disable-next-line no-eval
          // const userdata = eval(response.data.d);
          // setInvoicelList(userdata);
          // console.log(response.data.d);
          datesearch(fromdate, todate, bookedfilter);
          setLoaderstate(false);
          setUpdateMsg(true);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setUpdateMsg(false);
      }, 5000);
    }
  };

  const handlebetaversiontwo = () => {
    handleExportGridTwo();
  };

  const handleExportClick = () => {
    // setExportBtnFlag(true);
    handleExportGrid();
  };

  useEffect(() => {
    // setExportBtnFlag(exportflag);
    console.log('Export Flag', exportflag);
  }, [exportflag]);

  const handleUncheckedSingleFinal = (event, invoiceidsingle) => {
    // eslint-disable-next-line prefer-const
    let newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);

    setSelectedCustomerIds(newSelectedCustomerIds);
    for (let i = 0; i < newSelectedCustomerIds.length; i++) {
      for (let z = 0; z < invoicelist.length; z++) {
        if (
          // eslint-disable-next-line operator-linebreak
          invoicelist[z].inv_id === newSelectedCustomerIds[i] &&
          invoicelist[z].inv_id === invoiceidsingle
        ) {
          invoicelist[z].Itd_IsTransBooked = 'Pending';
          invoicelist[z].chkTransBooked = 'No';
          // console.log('Prev Invoice:::::::::::', invoicelist);
        }
      }
    }
  };

  const handleUncheckedSingle = (event, invoiceidsingle) => {
    setSingleSelectInv(invoiceidsingle);
    setOpenUnchecked(true);
  };
  const handleCloseUnchecked = () => {
    setOpen(false);
    setOpenView(false);
    setOpenUnchecked(false);
  };

  const handleReasonChange = (event) => {
    setInvreason(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleReason = () => {
    const clientid = localStorage.getItem('tranuserid');
    setErrorMsg(false);
    try {
      if (invreason === '') {
        setErrorMsg(true);
      } else {
        setOpenUnchecked(false);
        axios
          .post(`${URL}trans_updateitems`, {
            userid: clientid,
            qtype: '4',
            invoiceId: singleselectinv,
            remarks: invreason,
            bookstatus: '0',
            disstatus: '0',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
            }
          })
          .then((response) => {
            // eslint-disable-next-line no-eval
            // const userdata = eval(response.data.d);
            // setInvoicelList(userdata);
            console.log(response.data.d);
            // datesearch(fromdate, todate);
            handleUncheckedSingleFinal('', singleselectinv);
            datesearch(fromdate, todate, bookedfilter);
          })
          .catch((error) => {
            console.log('API error', error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeliveryListData = (invoiceData, date) => {
    axios
      .post(`${URL}ViewExtraCharge`, {
        invoiceno:
          editInvoiceData && editInvoiceData ? editInvoiceData : invoiceData,
        ddate: invoiceDate && invoiceDate ? invoiceDate : date,
        qtype: '2',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
        }
      })
      .then((response) => {
        if (response.data.d !== '') {
          const responseData = JSON.parse(response.data.d);
          setDeliveryEditData(responseData);
        } else setDeliveryEditData([]);
      })
      .catch((error) => {
        console.log('API error', error);
      });
  };

  const handleDeleteData = (data) => {
    try {
      axios
        .post(`${URL}DeleteExtraCharge`, {
          invoiceno: editInvoiceData && editInvoiceData,
          qtype: '4',
          uniq_id_ec: data.sno,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          handleDeliveryListData();
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (errorMessage) {
      console.log('Error message in delete method', errorMessage);
    }
  };

  const handleInserNewData = async () => {
    if (editInvoiceDate === '') {
      setSneakOpen(true);
      setSneakBarMessage('Please select Dropdown value');
    } else if (insertPrice === '') {
      setSneakOpen(true);
      setSneakBarMessage('Please enter amount');
    } else {
      axios
        .post(`${URL}sExtraCharge`, {
          invoiceno: editInvoiceData,
          description: dropDownData,
          amount: insertPrice,
          ddate: invoiceDate && invoiceDate,
          code: editInvoiceDate,
          uniq_id_ec: '',
          qtype: '1',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          setInsertPrice('');
          setSneakBarMessage('');
          handleDeliveryListData();
        })
        .catch((error) => {
          console.log('API error', error);
        });
    }
  };

  // const handleSaveInovice = (inv, date) => {
  //   try {
  //     axios
  //       .post(`${URL}sTrnasinvoivemain`, {
  //         invoiceno: inv,
  //         fdate: date,
  //         qtype: '1',
  //         headers: {
  //           'Access-Control-Allow-Origin': '*',
  //           'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
  //         }
  //       })
  //       .then(() => {
  //         console.log('Inside save Invoice');
  //       })
  //       .catch((error) => {
  //         console.log('API error', error);
  //       });
  //   } catch (errorMessage) {
  //     console.log('Error inside handle save invoice', errorMessage);
  //   }
  // };

  // const handleOpenEdit = (inv, date, amount) => {
  //   setInvoiceAmount(amount);
  //   setInvoiceDate(date);
  //   handleSaveInovice(inv, date);
  //   setOpenEdit(true);
  //   setEditInvoiceData(inv);
  //   handleDeliveryListData(inv, date);
  // };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ flexGrow: 1 }} style={{ display: 'block' }}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: '10px', paddingLeft: '10px' }}
          >
            <Grid item xs={1}>
              <Button variant="contained" onClick={handleUpdateSelected}>
                Book
              </Button>
            </Grid>
            {hide && (
              <Grid item xs={1}>
                {exportflag && (
                  <Button variant="contained" onClick={handleExportClick}>
                    Export
                  </Button>
                )}
                {!exportflag && (
                  <ReactHTMLTableToExcel
                    color="primary"
                    table="emp1"
                    filename="ReportExcel"
                    sheet="sheet"
                    buttonText="Download"
                    className={classes.root}
                  />
                )}
              </Grid>
            )}


            <Grid item xs={1.4}>
              {exportflagver && (
                <Button variant="contained" onClick={handlebetaversiontwo}>
                  Export (Beta)
                </Button>
              )}
              {!exportflagver && (
                <ReactHTMLTableToExcel
                  color="primary"
                  table="emp2"
                  filename="ReportExcel"
                  sheet="sheet"
                  buttonText="Download"
                  className={classes.root}
                />
              )}
            </Grid>




            <Grid item xs={1.6}>
              {exportflagverCSV && (
                <Button variant="contained" onClick={handelCsvButon}>
                  Export (Csv)
                </Button>
              )}
              {!exportflagverCSV && (
                <CSVLink style={csvbutton} data={invoicelistexportcsv}>
                  Download CSV
                </CSVLink>
              )}
            </Grid>


            <Loader
              visible={loaderstate}
              type="Puff"
              color="#00BFFF"
              height={45}
              width={45}
              timeout={300000}
            />

            <Box
              sx={{ flexGrow: 1 }}
              style={{
                marginTop: '24px',
                fontWeight: 'bolder'
              }}
            >
              {loaderstate === false && invoicelist && invoicelist.length === 0
                ? 'Sorry there is no records for this filter'
                : ''}
            </Box>
            {/* {console.log(
              '???????????????????????????????????????',
              loaderstate
            )} */}

            {/* <Loader
              visible={loaderstate}
              type="Puff"
              color="#00BFFF"
              height={45}
              width={45}
              timeout={300000}
            /> */}
            {updatemsg && (
              <Box
                sx={{ flexGrow: 1 }}
                style={{
                  marginTop: '24px'
                }}
              >
                {' '}
                Successfully Updated!
              </Box>
            )}

            <Box
              sx={{ flexGrow: 1 }}
              style={{
                marginTop: '24px',
                textAlign: 'right',
                paddingRight: '30px',
                fontWeight: '600',
                fontSize: '20px'
              }}
            >
              {' '}
              Total Records {totalinvoice}
            </Box>
            {/* )} */}
          </Grid>
        </Box>
        <Box
          sx={{ flexGrow: 1 }}
          style={{
            marginTop: '24px',
            color: 'red',
            fontWeight: 'bolder',
            marginLeft: '10px'
          }}
        >

          For best download results, select date range between 1 to 5 days.

        </Box>
        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedCustomerIds.length === invoicelist.length}
                    color="primary"
                    indeterminate={
                      // eslint-disable-next-line operator-linebreak
                      selectedCustomerIds.length > 0 &&
                      selectedCustomerIds.length < invoicelist.length
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell>

                <TableCell>Invoice Id</TableCell>
                <TableCell>Contact Details</TableCell>
                <TableCell>Customer Name</TableCell>
                <TableCell>DeliveryType</TableCell>
                <TableCell>DeliveryDate</TableCell>
                <TableCell>Booked Status</TableCell>
                {/* <TableCell>Payment Status</TableCell> */}
                <TableCell>Dispatch</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell>View</TableCell>
                {/* <TableCell>Payment</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicelist
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((customer, index) => (
                  <TableRow hover key={index[0]}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={customer.chkTransBooked === 'Yes'}
                        onClick={
                          (event) =>
                            handleSelectSingle(event, customer.inv_id)
                        }
                      />
                      {customer.chkTransBooked === 'Yes' && customer.CustomerName !== "ERP Request Job Type" ? (
                        <UndoIcon
                          style={{ cursor: 'pointer', marginLeft: '8px' }}
                          onClick={
                            (event) =>
                              handleUncheckedSingle(event, customer.inv_id)
                          }
                        />
                      ) : null}
                    </TableCell>
                    <TableCell>{customer.inv_id}</TableCell>
                    <TableCell>
                      {customer.inv_address}
                      <br />
                      {customer.inv_email}
                      <br />
                      {customer.inv_mobile && (
                        <>
                          {customer.inv_mobile} <br />
                        </>
                      )}
                      {customer.Inv_phone && (
                        <>
                          {customer.Inv_phone}
                          <br />
                        </>
                      )}
                      {customer.inv_state}
                    </TableCell>
                    <TableCell>{customer.CustomerName}</TableCell>
                    <TableCell>{customer.Delivery_Type}</TableCell>
                    <TableCell>
                      {moment(customer.Itd_deldate).format('DD-MM-YYYY')}
                    </TableCell>
                    {/* <TableCell>{customer.Public_comment}</TableCell> */}
                    {/* <TableCell> {customer.Invoicestatus} </TableCell> */}
                    <TableCell>{customer.Itd_IsTransBooked}</TableCell>
                    {/* <TableCell>{customer.statustransport}</TableCell> */}

                    <TableCell padding="checkbox">
                      <Checkbox
                        disabled
                        checked={customer.Itd_IsTransDispatched === 'Yes'}
                        value="true"
                      />
                    </TableCell>
                    <TableCell
                      onClick={
                        (event) =>
                          // eslint-disable-next-line implicit-arrow-linebreak
                          handleOpen(
                            event,
                            customer.inv_id,
                            customer.Itd_Trans_Remarks,
                            'remarks'
                          )
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    >
                      <EditIcon />
                    </TableCell>
                    <TableCell
                      style={{ color: customer.color1 == "1" ? 'red' : null }}
                      onClick={
                        (event) =>
                          // eslint-disable-next-line implicit-arrow-linebreak
                          handleOpen(
                            event,
                            customer.inv_id,
                            customer.Itd_Trans_Remarks,
                            'view'
                          )
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    >
                      <PreviewIcon />
                    </TableCell>

                    {/* <TableCell>
                      <Button
                        variant="contained"
                        onClick={
                          () =>
                            // eslint-disable-next-line implicit-arrow-linebreak
                            handleOpenEdit(
                              customer.inv_id,
                              customer.Itd_deldate,
                              customer.Inv_delcharge
                            )
                          // eslint-disable-next-line react/jsx-curly-newline
                        }
                      >
                        Payment
                      </Button>
                    </TableCell> */}
                  </TableRow>
                ))}
            </TableBody>

            <TableRow>
              <TableCell colSpan={10}>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 100, 200]}
                  component="div"
                  count={invoicelist.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableCell>
            </TableRow>
          </Table>
          <table id="emp1" style={{ display: 'none' }}>
            <thead>
              <tr>
                <th>Invoice Id</th>
                <th> DeliveryComments</th>
                <th>ServiceDescriptions</th>
                <th>GoodSummary</th>
                <th>Qty</th>
                <th>Boxes</th>
                <th>CBM</th>
                <th>PickupName</th>
                <th>PickupStreet</th>
                <th>PickupSuburb</th>
                <th>PickupPostCode</th>
                <th>PickupState</th>
                <th>DeliveryName</th>
                <th>DeliveryStreet</th>
                <th>DeliverySuburb</th>
                <th>DeliveryPostCode</th>
                <th>DeliveryState</th>
                <th>DeliveryCharge</th>
                <th>Phone</th>
                <th>Booked Status</th>

                {/* <th>Contact Details</th>
                <th>Phone</th>
                <th>Email</th>
                <th>State</th>
                <th>Delivery Charges</th>
                <th>Delivery Date</th>
                <th>Comments</th>
                <th>Remarks</th>
                <th>Booked</th>
                <th>Dispatched</th>
                <th>CBM</th>
                <th>TotalBoxes</th>
                <th>Barcode</th>
                <th>Qty</th>
                <th>Invoice Status</th> */}
              </tr>
            </thead>
            <tbody>
              {exportlist.map((customer) => (
                <tr key={customer.sno}>
                  <td>{customer.invoiceId}</td>
                  <td>{customer.DeliveryComments}</td>
                  <td>{customer.ServiceDescription}</td>
                  <td>{customer.GoodsSummary}</td>
                  <td>{customer.Qty}</td>
                  <td>{customer.Boxes}</td>
                  <td>{customer.CBM}</td>
                  <td>{customer.PickupName}</td>
                  <td>{customer.PickupStreet}</td>
                  <td>{customer.PickupSuburb}</td>
                  <td>{customer.PickupPostcode}</td>
                  <td>{customer.PickupState}</td>
                  <td>{customer.DelivaryName}</td>
                  <td>{customer.DelivaryStreet}</td>
                  <td>{customer.DelivarySuburb}</td>
                  <td>{customer.DelivaryPostcode}</td>
                  <td>{customer.DelivaryState}</td>
                  <td>{customer.DelivaryCharges}</td>
                  <td>{customer.Phone}</td>
                  <td>{customer.Itd_IsTransBooked}</td>

                  {/* <td>{customer.ContactDtls}</td>
                  <td>{customer.contact}</td>
                  <td>{customer.Email}</td>
                  <td>{customer.State}</td>
                  <td>{customer.DelCharge}</td>
                  <td>{customer.DelDate}</td>
                  <td>{customer.Comments}</td>
                  <td>{customer.Remarks}</td>
                  <td>{customer.Booked}</td>
                  <td>{customer.Dispatched}</td>
                  <td>{customer.CBM}</td>
                  <td>{customer.TotalBoxes}</td>
                  <td>{customer.Barcode}</td>
                  <td>{customer.Qty}</td>
                  <td>{customer.Invoicestatus}</td> */}
                </tr>
              ))}
            </tbody>
          </table>

          <table
            id="emp2"
            style={{ display: 'none' }}
            cellSpacing="5"
            cellPadding="5"
          >
            <thead>
              <tr bgcolor="skyblue" style={{ border: '1px solid black' }}>
                <th>Invoice ID</th>
                <th>Goods Summary</th>
                <th>Qty</th>
                <th>Number of Boxes</th>
                <th>Item Weight</th>
                <th>CBM</th>
                <th>Source</th>
                <th>Delivery Type</th>
                <th>Deluxe</th>
                {/* <th>Heavy</th> */}
                <th>Customer Name</th>
                <th>Customer Email Id</th>
                <th>Customer Address</th>
                <th>Customer Phone</th>
                <th>Delivery Comments</th>
                <th>Delivery Charges</th>
              </tr>
            </thead>
            <tbody>
              {exportlisttwo.map((customer) => (
                <tr key={customer.sno}>
                  <td>{customer.invoiceid}</td>
                  <td>{customer.goodssummary}</td>
                  <td>{customer.qty}</td>
                  <td>{customer.numberofboxes}</td>
                  <td> {customer.ItemWeight}</td>
                  <td>{customer.cbm}</td>
                  <td>{customer.source}</td>
                  <td>{customer.deliverytype}</td>
                  <td>{customer.delux}</td>
                  {/* <td>{customer.heavy}</td> */}
                  <td>{customer.customername}</td>
                  <td>{customer.CustomerEmail}</td>
                  <td>{customer.customeraddress}</td>
                  <td>{customer.customerphone}</td>
                  <td>{customer.customercomments}</td>
                  <td>{customer.deliverycharges}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </PerfectScrollbar>
      {/* Remarks model */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
          ></Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Remarks"
              multiline
              rows={8}
              defaultValue={invremarks}
              columns={20}
              onChange={handleRemarksChange}
            />
            {errormsg && (
              <Typography sx={istyle}>Please enter remarks </Typography>
            )}
          </Typography>
          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Button variant="contained" onClick={handleRemarks}>
              Save Remarks
            </Button>
          </Typography>
        </Box>
      </Modal>

      {/* view data model */}
      <Modal
        open={openview}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        contentStyle={{ width: '800%', maxWidth: 'none' }}
      >
        <Box sx={styletable}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Invoice No {invoiceid}
            </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Items are filtered as per the selected delivery dates
            </Typography>
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Box sx={{ minWidth: 550 }}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Prd short Desc</TableCell>
                      <TableCell>Bar Code</TableCell>
                      <TableCell>ProductType</TableCell>
                      <TableCell>Qty</TableCell>
                      <TableCell>Total Boxes</TableCell>
                      <TableCell>Total CBM</TableCell>
                      <TableCell>Delivery Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceviewlist
                      .sort((a, b) => (a.Bar_barcode > b.Bar_barcode ? 1 : -1))
                      .map((customer, index) => (
                        <TableRow hover key={index[1]}>
                          <TableCell>{customer.Prd_shortdesc}</TableCell>
                          <TableCell>{customer.Bar_barcode}</TableCell>
                          <TableCell>{customer.ProductType}</TableCell>
                          <TableCell>{customer.Itd_qty}</TableCell>
                          <TableCell>{customer.TotalBoxes}</TableCell>
                          <TableCell>{customer.TotalCBM}</TableCell>
                          <TableCell>{customer.DeliveryType}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow sx={stylefooter}>
                      <TableCell colSpan={2}>Total</TableCell>
                      <TableCell>{ }</TableCell>
                      <TableCell>{parseFloat(totalqty)}</TableCell>
                      <TableCell>
                        {parseFloat(saleReturn) > parseFloat(standard)
                          ? parseFloat(saleReturn)
                          : parseFloat(standard)}
                      </TableCell>
                      <TableCell>{totalcbm}</TableCell>
                    </TableRow>
                    <TableRow
                      sx={stylefooter}
                      style={{ backgroundColor: '#F5F5F5' }}
                    >
                      <TableCell>{ }</TableCell>
                      <TableCell
                        colSpan={2}
                        style={{
                          marginTop: '24px',
                          paddingRight: '30px',
                          fontWeight: '600',
                          color: 'black',
                          fontSize: '17px'
                        }}
                      >
                        Total Boxes
                      </TableCell>
                      <TableCell
                        style={{
                          marginTop: '24px',
                          paddingRight: '30px',
                          fontWeight: '600',
                          color: 'black',
                          fontSize: '17px'
                        }}
                      >
                        {saleReturn} Sales Return
                      </TableCell>
                      <TableCell
                        style={{
                          marginTop: '24px',
                          paddingRight: '30px',
                          fontWeight: '600',
                          color: 'black',
                          fontSize: '17px'
                        }}
                      >
                        {standard} Standard
                      </TableCell>
                      <TableCell>{ }</TableCell>
                      <TableCell>{ }</TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Box>
          </Typography>
          <Typography
            id="modal-modal-footer"
            sx={{ mt: 2 }}
            style={{ textAlign: 'center' }}
          >
            <Button variant="contained" onClick={handleClose}>
              Close
            </Button>
          </Typography>
        </Box>
      </Modal>

      {/* Eidt Invoice */}
      <Modal
        open={openEdit}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        contentStyle={{
          width: '800%',
          maxWidth: 'none',
          backgroundColor: '#dcdcdc'
        }}
      >
        <Box sx={styletable} className="InvoicePopup">
          <Typography id="modal-modal-title" variant="h5" component="h5">
            Invoice No. {editInvoiceData}
          </Typography>
          <div className="SectionOne">
            <Typography id="modal-modal-title" variant="h3" component="h3">
              Delivery charge amount
            </Typography>
            <Typography id="modal-modal-title" variant="h3" component="h3">
              {invoiceAmount && invoiceAmount}
            </Typography>
          </div>

          <Box sx={{ minWidth: 550 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                backgroundColor: '#fff',
                padding: '20px 20px'
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ margin: '0px 0px 0px 32px' }}
                      >
                        Select value
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={editInvoiceDate}
                        label="Select value"
                        onChange={handleChangeselect}
                      >
                        <MenuItem value={2}>Assembly</MenuItem>
                        <MenuItem value={0}>Cancellation</MenuItem>
                        <MenuItem value={1}>Labour Hire</MenuItem>
                        <MenuItem value={3}>Rubbish Removal</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      label="Extra charge amount"
                      size="small"
                      id="outlined-start-adornment"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        )
                      }}
                      placeholder="Amount"
                      value={insertPrice}
                      onChange={handleInsertPrice}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Typography id="modal-modal-footer">
                      <Button variant="contained" onClick={handleInserNewData}>
                        ADD
                      </Button>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </div>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>Data</TableCell>
                    <TableCell>Amount($)</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Action</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell> { }</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deliveryEditData.map((customer) => (
                    <TableRow hover>
                      <TableCell> {customer.Ec_Description} </TableCell>
                      <TableCell> {customer.Ec_Amount} </TableCell>
                      <TableCell> {customer.Column2} </TableCell>
                      <TableCell>
                        {' '}
                        {customer.Status === '1'
                          ? 'Approve'
                          : 'Unapproved'}{' '}
                      </TableCell>

                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          size="medium"
                          onClick={() => handleDeleteData(customer)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                      <TableCell> { } </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <div className="PopupFooter">
            <Button
              variant="outlined"
              style={{ margin: '0px 4px 0px 0px' }}
              onClick={handleClose}
            >
              CANCEL
            </Button>
            <Button variant="contained" onClick={handleConfirmEditExcel}>
              CONFIRM
            </Button>
          </div>
        </Box>
      </Modal>
      {/* End Edit  */}

      {/* Uncheck reason model */}
      <Modal
        open={openunchecked}
        onClose={handleCloseUnchecked}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
          ></Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Reason"
              multiline
              rows={8}
              defaultValue={invremarks}
              columns={20}
              onChange={handleReasonChange}
            />
            {errormsg && (
              <Typography sx={istyle}>Please enter reason </Typography>
            )}
          </Typography>
          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Button variant="contained" onClick={handleReason}>
              Save Reason
            </Button>

            <Button
              style={{ marginLeft: '5px' }}
              variant="contained"
              onClick={handleCloseUnchecked}
            >
              Close
            </Button>
          </Typography>
        </Box>
      </Modal>

      <Snackbar
        open={sneakOpen}
        autoHideDuration={6000}
        onClose={handleCloseSneakBar}
      >
        <Alert
          onClose={handleCloseSneakBar}
          severity="error"
          sx={{ width: '100%' }}
        >
          {sneakBarMessage && sneakBarMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
};

CustomerListResults.propTypes = {
  customers: PropTypes.array.isRequired
};

export default CustomerListResults;
